import React, { PropsWithChildren } from 'react';
import { Button as LibButton, ButtonProps as LibButtonProps } from '@round/ui-kit';
import styles from './Button.module.css';
import cn from 'classnames';

const Button = ({ className, ...props }: PropsWithChildren<LibButtonProps>) => {
    return <LibButton className={cn(styles.button, className)} {...props} />;
};

export default Button;
